import { defineMessages } from 'react-intl';

export default defineMessages({
    teacherViewYou: {
        id: 'teacher-roll.container.teacherView.you',
        defaultMessage: 'You'
    }
});



// WEBPACK FOOTER //
// ./app/containers/teacher-view/messages.js